<template>
  <div>

    <div>
      <div id="printMe_warehouse_output_header"></div>
      <div id="printMe_warehouse_output_footer"></div>
      <CRow class="m-1">
        <CCol col="3">
          <date-picker
              :label="$t('components.startDate')"
              v-model="start_date"></date-picker>
        </CCol>
        <CCol col="3">
          <date-picker
              :label="$t('components.endDate')"
              v-model="end_date"></date-picker>

        </CCol>

        <CCol col="2">
          <CButton @click="get_all_data()" size="sm" color="secondary">
            {{ $t('search') }}
          </CButton>
        </CCol>
        <CCol col="2">
          <CButton @click="change_product_status_modal=true"
                   type="submit" size="sm" color="secondary">
            {{ $t('acceptExitProducts') }}
          </CButton>
        </CCol>
        <CCol col="2">
          <CButton @click="print_data()"
                   type="submit" size="sm" color="secondary">
            {{ $t('buttons.print') }}
          </CButton>
        </CCol>

      </CRow>

      <div id="printMe_warehouse_output">

        <CDataTableFixed
            :items="exit_product_inventory_items"
            :fields="exit_product_inventory_fields"
            striped
            border
            sorter

            :checkbox="true"
            checkbox_key="productId"
            :checkbox_ids.sync="product_checkbox_items_exit"


            :height="get_pagination? '300px' : ''"
            column-filter
            :pagination="get_pagination"

            :items-per-page="200"
            hover

        >


          <template #productCode="{item}">
            <td>
              <p style="text-align: center">{{ item.productCode }}</p>
            </td>
          </template>
          <template #masterCode="{item,index}">
            <td>
              <p style="text-align: center">{{ index + 1 }}</p>
            </td>
          </template>
          <template #qty="{item}">
            <td>
              <p style="text-align: right">{{ Math.abs(item.qty) }}</p>
            </td>
          </template>
          <template #existance="{item}">
            <td>
              <p style="text-align: right">{{ item.existance }}</p>
            </td>
          </template>
        </CDataTableFixed>


      </div>

    </div>

    <CModal
        :show.sync="change_product_status_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          {{ $t('sureToConfirm') }}
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="change_product_status_data(0)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_product_status_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';


export default {
  name: 'Login',
  components: {

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      start_date: '',
      end_date: '',
      change_product_status_modal: false,


      change_status_summary: '',
      product_checkbox_items_exit: [],

      exit_product_inventory_items: [],
      exit_product_inventory_fields: [
        // {key: 'select', label: this.$t('tables.select'), _style: 'width:2%'},

        {key: 'masterCode', label: this.$t('tables.number'), _style: 'width:5%'},
        // {key: 'انبار', _style: 'width:10%'},
        {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:10%'},

        {key: 'productName', label: this.$t('components.productName'), _style: 'width:20%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:10%'},
        // {key: 'existance', label: this.$t('balanceQty'), _style: 'width:10%'},
        // {key: 'toziKonande', label: this.$t('tables.driver'), _style: 'width:15%'},


        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],


      status_form: 0,
    }
  },
  mounted() {

    this.start_date = this.get_today();
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();

  }, watch: {



  },
  methods: {

    print_data() {
      // Pass the element id here
      this.print_with_header('printMe_warehouse_output', 'printMe_warehouse_output_header'
          , 'printMe_warehouse_output_footer');
    },

    change_product_status_data(index) {

      if (this.product_checkbox_items_exit.length == 0) {
        return false;

      }
      this.change_product_status_modal = false;
      var self = this;

      const formData = new FormData();
      formData.append('ProductId', this.product_checkbox_items_exit[index]);
      // formData.append('Ids[]', 0);

      const pros = this.exit_product_inventory_items.filter(x => x.productId == this.product_checkbox_items_exit[index])[0]
console.log("pros check",pros)
      pros.masterIds.forEach(function (val) {
        formData.append('Ids[]', val);

      })
      formData.append('FacStatus', 1);

      axios.post('AddFactorPlatform', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if (index < self.product_checkbox_items_exit.length - 1) {
            self.change_product_status_data(index + 1);
          } else {
            self.product_checkbox_items_exit = []
            self.get_exit_products();
          }


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });
    },


    get_all_data() {
      this.get_exit_products();
    },

    get_exit_products() {
      var self = this;
      self.exit_product_inventory_items = []
      const formData = new FormData();

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);
      formData.append('DocType', 3);
      formData.append('StatusList[]', 24);


      axios.post('GetDocsByForOutputEntry', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.exit_product_inventory_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          let grouping = []

          self.exit_product_inventory_items.forEach(function (val) {
            if (grouping.filter(x => x.productId == val.productId).length > 0) {
              grouping.filter(x => x.productId == val.productId)[0].qty += val.qty
              grouping.filter(x => x.productId == val.productId)[0].masterIds.push(val.masterId)
            } else {
              val.masterIds = []
              val.masterIds.push(val.masterId)
              grouping.push(val)

            }
          })
          self.exit_product_inventory_items = grouping.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
